var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"img-container"},[_c('div',{attrs:{"id":"croppie"},on:{"change":_vm.changeCroppedImg}})])
}
var staticRenderFns = []

export { render, staticRenderFns }